<template>
  <div class="content-box">
    <banner-box />
    <!-- <p class="desc">
      双華株式会社は「木材」、「合板」、「び建築用資材」の3分野で事業を展開している。<br />
      お客様から信頼されるパートナーを目指し、最適なホーム、木材を提案します。
    </p> -->

    <div class="btns">
      <p
        v-for="(item, index) in btnData"
        class="btn"
        :class="{active: curSelect === index}"
        :key="index"
        @click="handleSelect(index)"
      >
        <span class="name">{{item.name}}</span>
        <span class="img">↓</span>
      </p>
    </div>

    <div class="content">
      <div class="selects">
        <p class="title">Service</p>
        <div class="items">
          <p
            v-for="(item, index) in btnData"
            class="item"
            :class="{active: curSelect === index}"
            :key="index"
            @click="handleSelect(index)"
          >{{item.name}}</p>
        </div>
      </div>
      <p class="line"></p>
      <div class="rows">
        <div
          v-for="(item, index) in btnData[curSelect].data"
          class="row"
          :key="index"
        >
          <p class="title">
            {{item.title}}
            <span class="subTitle">{{item.subTitle}}</span>
          </p>
          <p class="url-box">
            <img class="img" :src="item.url" alt="img">
          </p>
          <p class="name">
            {{item.name}}
            <span class="subName">{{item.subName}}</span>
          </p>
          <textarea class="content-box" v-model="item.content" readonly />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { synr } from '../../api/home'

export default {
  name: 'index',
  data () {
    return {
      curSelect: 0,
      btnData: [
        // {
        //   name: '木材',
        //   data: [
        //     {
        //       title: '木材',
        //       subTitle: 'Wood',
        //       url: '',
        //       name: '日本原木と保持',
        //       subName: '密接なつながりの優先方法',
        //       content: '設立以来、SOUKA CONRPORATIONは木材、ベニヤ板及び建築用\n' +
        //       '材料の販売及び輸出入業務を行ってきた。'
        //     }
        //   ]
        // },
        // {
        //   name: '合板',
        //   data: [
        //     {
        //       title: '合板',
        //       subTitle: 'Plywood',
        //       url: '',
        //       name: '各業界の',
        //       subName: '製造技術が革新をもたらす',
        //       content: '設立以来、SOUKA CONRPORATIONは木材、ベニヤ板及び建築用\n' +
        //         '材料の販売及び輸出入業務を行ってきた。'
        //     }
        //   ]
        // },
        // {
        //   name: '建材',
        //   data: [
        //     {
        //       title: '建材',
        //       subTitle: 'Building Materials',
        //       url: '',
        //       name: '各業界の',
        //       subName: '製造技術が革新をもたらす',
        //       content: '東京ビックサイトで第30回建築.建材展2024に出展しました。'
        //     }
        //   ]
        // }
      ]
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getContentData()
    },
    async getContentData () {
      const { data } = await synr()
      console.log('getContentData==>', data)
      this.btnData = data.map(v => {
        return {
          name: v.pic_title,
          data: [
            {
              title: v.pic_title,
              subTitle: v.pic_title_en,
              url: v.coverPath,
              name: v.title,
              subName: '',
              content: v.description
            }
          ]
        }
      })
    },
    handleSelect (index) {
      this.curSelect = index
    }
  }
}
</script>

<style lang="less" scoped>
  .content-box{
    display: flex;
    flex-direction: column;

    .desc{
      font-family: 04KanjyukuGothic;
      font-weight: 400;
      font-size: 20px;
      color: #666666;
      line-height: 34px;
      margin-top: 58px;
      margin-left: 279px;
    }

    .btns{
      margin-top: 53px;
      margin-left: 259px;
      display: flex;
      flex-direction: row;
      align-items: center;

      .btn{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: 0px 48px;
        height: 81px;
        background: #E6F0F7;
        border-radius: 40px;
        text-align: center;
        margin-right: 46px;
        cursor: pointer;
        transition: all .2s linear;

        &.active{
          background: #374475;

          .name{
            color: #f6f6f6;
          }
        }

        .name{

          font-weight: 400;
          font-size: 30px;
          color: #374475;
          line-height: 81px;
        }

        .img{
          flex-shrink: 0;
          width: 27px;
          height: 27px;
          background: #E6F0F7;
          border-radius: 50%;
          border: 2px solid #374475;
          display: inline-block;
          line-height: 27px;
          font-size: 12px;
          font-weight: bold;
          margin-left: 18px;
        }
      }
    }

    .content{
      margin-top: 68px;
      margin-left: 259px;
      display: flex;
      flex-direction: row;
      align-items: flex-start;

      position: relative;

      .selects{
        display: flex;
        flex-direction: column;
        padding-bottom: 122px;
        width: 371px;

        .title{
          font-weight: 400;
          font-size: 24px;
          color: #374475;
          margin-left: 31px;
          margin-top: 28px;
          margin-bottom: 24px;
        }

        .items {
          margin-top: 32px;

          .item {
            height: 23px;
            font-family: 04 KanjyukuGothic;
            font-weight: 400;
            font-size: 24px;
            color: #cccccc;

            padding-left: 31px;
            margin-bottom: 27px;

            position: relative;
            cursor: pointer;

            &.active{
              color: #374475;

              &:before{
                background: #374475;
              }
            }

            &:before{
              content: '';
              position: absolute;
              top: 14px;
              left: 4px;
              width: 6px;
              height: 6px;
              background: #CCCCCC;
              border-radius: 50%;
            }
          }
        }
      }

      .line{
        position: absolute;
        top: 0px;
        left: 296px;
        width: 1px;
        height: 100%;
        background-color: #cccccc;

        &:before{
          content: '';
          width: 12px;
          height: 12px;
          background: #374475;
          border-radius: 6px;
          position: absolute;
          top: -6px;
          left: -6px;
        }
      }

      .rows{
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .row {
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          .title {
            height: 98px;
            padding: 0px 33px;
            background: #374475;
            border-radius: 10px 10px 10px 0px;

            font-family: 04 KanjyukuGothic;
            font-weight: 400;
            font-size: 24px;
            color: #FFFFFF;
            line-height: 98px;
            text-align: center;
            position: relative;
            z-index: 10;

            .subTitle {
              position: relative;
              border-left: 1px solid #fff;
              margin-left: 20px;
              padding-left: 26px;
            }
          }

          .url-box {
            width: 1029px;
            height: 571px;
            /*background: wheat;*/
            border-radius: 10px;
            margin-top: -41px;

            .img{
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .name {
            font-family: 04 KanjyukuGothic;
            font-weight: 400;
            font-size: 36px;
            color: #374475;
            line-height: 34px;
            margin-top: 57px;

            .subName{
              display: block;
              margin-top: 10px;
            }
          }

          .content-box {
            width: 872px;
            height: 200px;
            font-family: 04 KanjyukuGothic;
            font-weight: 400;
            font-size: 20px;
            color: #333333;
            line-height: 30px;
            border: none;
            outline: none;
            user-select: none;
            margin-top: 28px;
          }
        }
      }
    }
  }
</style>
